// Default 10 equal sectors covering 0..1 of the lap. Shared by the analysis
// view (App) and the Search page so both seed unset tracks identically.
export function defaultSectors(n = 10) {
  const arr = [];
  for (let i = 0; i < n; i++) {
    arr.push({
      id:         `S${i + 1}`,
      label:      `Sector ${i + 1}`,
      start_frac: i / n,
      end_frac:   (i + 1) / n,
    });
  }
  return arr;
}
